module.exports = __webpack_public_path__ + "img/lavista.d6d21e29.svg";